// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminExerciseImportController from "./admin_exercise_import_controller"
application.register("admin-exercise-import", AdminExerciseImportController)

import AutoExpandController from "./auto_expand_controller"
application.register("auto-expand", AutoExpandController)

import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)

import ExerciseHistoryController from "./exercise_history_controller"
application.register("exercise-history", ExerciseHistoryController)

import ExerciseSetsController from "./exercise_sets_controller"
application.register("exercise-sets", ExerciseSetsController)

import ExerciseTemplateDetailsController from "./exercise_template_details_controller"
application.register("exercise-template-details", ExerciseTemplateDetailsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MuscleChartController from "./muscle_chart_controller"
application.register("muscle-chart", MuscleChartController)

import OneRmCalculatorController from "./one_rm_calculator_controller"
application.register("one-rm-calculator", OneRmCalculatorController)

import OneRmChartController from "./one_rm_chart_controller"
application.register("one-rm-chart", OneRmChartController)

import PhotoModalController from "./photo_modal_controller"
application.register("photo-modal", PhotoModalController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SortableSetsController from "./sortable_sets_controller"
application.register("sortable-sets", SortableSetsController)

import SoundController from "./sound_controller"
application.register("sound", SoundController)

import StopwatchController from "./stopwatch_controller"
application.register("stopwatch", StopwatchController)

import WeightChartController from "./weight_chart_controller"
application.register("weight-chart", WeightChartController)
